const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://127.0.0.1:8000";
const apiCall = async (endpoint, options = {}) => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: options.method || "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        ...options.headers,
      },

      body: options.body ? JSON.stringify(options.body) : undefined,
    });

    // if (!response.ok) {
    //   const errorData = await response.json().catch(() => ({}));
    //   throw new Error(errorData.message || `HTTP error ${response.status}`);
    // }

    const data = await response.json();
    return data;

    // return await response.json();
  } catch (error) {
    console.error(`API Error (${endpoint}):`, error);
    // throw error;

    return {
      success: false,
      message: "Network error. Please try again.",
    };
  }
};

// Categories
export const getCategories = async () => {
  try {
    return await apiCall("/categories");
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

// Menu Items
export const getMenuItems = async (categoryId = null) => {
  try {
    let endpoint = "/menu-items";
    if (categoryId && categoryId !== "all") {
      endpoint = `/menu-items/category/${categoryId}`;
    }
    return await apiCall(endpoint);
  } catch (error) {
    console.error("Error fetching menu items:", error);
    return [];
  }
};

// Get single menu item details
export const getMenuItemDetails = async (id) => {
  try {
    return await apiCall(`/menu-items/${id}`);
  } catch (error) {
    console.error("Error fetching menu item details:", error);
    throw error;
  }
};

// Coupons
export const getCoupons = async () => {
  try {
    const response = await apiCall("/coupons/active");
    return response.coupons || [];
  } catch (error) {
    console.error("Error fetching coupons:", error);
    return [];
  }
};

// Validate Coupon
export const validateCoupon = async (couponCode, total) => {
  try {
    return await apiCall("/validate-coupon", {
      method: "POST",
      body: {
        coupon_code: couponCode,
        total: total,
      },
    });
  } catch (error) {
    console.error("Error validating coupon:", error);
    return { valid: false, message: "Invalid coupon" };
  }
};

// Table Info
export const getTableInfo = async (tableNo) => {
  try {
    return await apiCall(`/tables/${tableNo}`);
  } catch (error) {
    console.error("Error fetching table info:", error);
    return { table_number: tableNo, status: "available" };
  }
};

// Place Order
export const placeOrder = async (orderData) => {
  try {
    return await apiCall("/save-order", {
      method: "POST",
      body: orderData,
    });
  } catch (error) {
    console.error("Error placing order:", error);
    throw error;
  }
};

// Get Order Status
export const getOrderStatus = async (orderId) => {
  try {
    const response = await apiCall(`/track-order/${orderId}`);
    return response.order;
  } catch (error) {
    console.error("Error fetching order status:", error);
    return null;
  }
};

export { API_BASE_URL, BASE_URL };
